import { render, staticRenderFns } from "./ListNeighborhoodPage.vue?vue&type=template&id=5f9636dc&"
import script from "./ListNeighborhoodPage.vue?vue&type=script&lang=js&"
export * from "./ListNeighborhoodPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports